var _path, _mask, _g, _path2, _path3, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCowboyHat = function SvgCowboyHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 41,
    viewBox: "0 0 80 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7596 1.42313C26.0396 -4.15023 22.97 24.5232 21.77 36.5566H55.77C53.77 26.8455 49.6796 1.42313 45.3596 1.42313C39.9596 1.42313 41.1596 8.38983 32.7596 1.42313Z",
    fill: "#D5AA6A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 35,
    height: 37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7596 1.42313C26.0396 -4.15023 22.97 24.5232 21.77 36.5566H55.77C53.77 26.8455 49.6796 1.42313 45.3596 1.42313C39.9596 1.42313 41.1596 8.38983 32.7596 1.42313Z",
    fill: "#D5AA6A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.77,
    y: 29.5566,
    width: 38,
    height: 7,
    fill: "#C5882B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.878687 18.9944C-3.37235 28.0643 12.8147 38.1657 19.0483 40.5566H58.2596C64.2921 40.5566 82.3437 26.8464 78.6981 17.6902C73.27 4.05663 68.27 3.55663 67.2363 20.9506C66.7324 29.4307 55.9757 34.2095 50.9486 35.2962C50.3453 35.5136 45.0367 35.8179 28.6283 35.2962C8.11772 34.6442 13.27 -7.44338 0.878687 18.9944Z",
    fill: "#D5AA6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.878687 18.9944C-3.37235 28.0643 12.8147 38.1657 19.0483 40.5566H58.2596C64.2921 40.5566 82.3437 26.8464 78.6981 17.6902C73.27 4.05663 68.27 3.55663 67.2363 20.9506C66.7324 29.4307 55.9757 34.2095 50.9486 35.2962C50.3453 35.5136 45.0367 35.8179 28.6283 35.2962C8.11772 34.6442 13.27 -7.44338 0.878687 18.9944Z",
    fill: "url(#cowboy_hat_paint0_linear)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cowboy_hat_paint0_linear",
    x1: 41.77,
    y1: 42.5566,
    x2: 39.77,
    y2: 17.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4872B",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCowboyHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cowboy_hat.2f843172.svg";
export { ForwardRef as ReactComponent };